'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGraphqlInterface = createGraphqlInterface;

var _es6Promise = require('es6-promise');

var _api = require('../../api');

require('isomorphic-fetch');
(0, _es6Promise.polyfill)();

function createGraphqlInterface() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _api.createDefaultInterface)('GRAPHQL', options);
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/api/graphql/index.js
// module id = 2087
// module chunks = 0